
import IndexLeft from '@/components/admin/IndexLeft'

export default [
  {
    path: '/formui/simple_form',
    name: 'FormUiForm',
    components: {indexLeft: IndexLeft
      , indexRight: () =>import('@/components/admin/base/FormUiForm') }
  },
  {
    path: '/formui/simple_table',
    name: 'SimpleTable',
    components: {indexLeft: IndexLeft
      , indexRight: () =>import('@/components/admin/base/SimpleTable') }
  },



]



// WEBPACK FOOTER //
// ./src/router/formuiRouter.js